import React, { Component } from "react";
import { connect } from "react-redux";
import MapGL from "react-map-gl";

import ScatterplotOverlay from "./scatterplot-overlay";
import CameraFovOverlay from "./camera-fov-overlay";
import DirectionOverlay from "../direction-overlay";

import { selectCurrentSkyviewFrame } from "../../ducks/videos";
import { typeScale } from "../../modules/colors";

import Styles from "./tracking-map.module.scss";
import { selectDuration } from "../../ducks/time";
import WebMercatorViewport from "viewport-mercator-project";

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const INITIAL_VIEW_STATE = {
    latitude: -37.81917910528,
    longitude: 144.95401578986773,
    zoom: 17,
    bearing: 0,
    pitch: 0,
    width: 100,
    height: 100,
};

class TrackingMap extends Component {

    constructor(props) {
        super(props);

        // This is only temporary - we fit to bounds as soon as we mount.
        const center = props.video.skyview ? props.video.skyview.center : [-37.819, 144.954];

        this.state = {
            viewport: {
                ...INITIAL_VIEW_STATE,
                longitude: center[0],
                latitude: center[1],
            },
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentDidUpdate(prevProps) {
        // This is a hacky way of saying once video has loaded
        if (!prevProps.duration && this.props.duration) {
            this.resize();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize = () => {
        if (!this.container) return;
        const bbox = this.container.getBoundingClientRect();
        const { width, height } = bbox;

        const newViewport = {
            ...this.state.viewport,
            width: width,
            height,
        }

        const newCoords = new WebMercatorViewport(newViewport)
            .fitBounds(this.props.video.skyview.extents, {
              padding: 40,
              offset: [0, 0]
            });

        this.setState({
            viewport: {
                ...newViewport,
                ...newCoords,
            },
        });
    };

    render() {
        const { currentSkyviewFrame, video } = this.props;
        if (!video.skyview) return null;

        const entities = currentSkyviewFrame
            ? currentSkyviewFrame.entities
            : [];
        
        return (
            <div className={Styles.trackingMap} ref={r => (this.container = r)}>
                <MapGL
                    mapboxApiAccessToken={MAPBOX_TOKEN}
                    reuseMaps
                    mapStyle="mapbox://styles/mapbox/dark-v9"
                    preventStyleDiffing
                    onViewportChange={viewport => this.setState({ viewport })}
                    {...this.state.viewport}
                >
                    <CameraFovOverlay
                        video={video}
                    />
                    <ScatterplotOverlay
                        data={entities}
                        dotRadius={6}
                        compositeOperation="lighter"
                        getPosition={d => d.coords}
                        getColor={d => typeScale[d.type]}
                    />
                    <DirectionOverlay />
                </MapGL>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        currentSkyviewFrame: selectCurrentSkyviewFrame(state, props.video),
        duration: selectDuration(state),
    };
};
const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrackingMap);



// WEBPACK FOOTER //
// ./src/components/tracking-map/tracking-map.js